<template>
  <div>
    <el-header class="header">
      <div class="left" id="logo">
        <img src="~@/assets/logo.png">
        <span>
          链捷科技
        </span>
      </div>
      <div class="nav">
        <div id="call-content"></div>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            {{ name }}
            <i class="el-icon-arrow-down el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="updatePwd">
              修改密码
            </el-dropdown-item>
            <el-dropdown-item command="logout">
              退出登录
              <form id="logout-form" action="/logout" method="POST" style="display: none;" />
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <div>
      <!-- 新增队列 -->
      <el-drawer :visible.sync="dialogFormVisible" label-width="80px" title="修改密码">
        <el-form :model="form">
          <el-form-item label="用户名">
            <el-input v-model.trim="form.mobile" />
          </el-form-item>
          <el-form-item label="旧密码">
            <el-input v-model.trim="form.password" />
          </el-form-item>
          <el-form-item label="新密码">
            <el-input v-model.trim="form.newPasswd" type="password" />
          </el-form-item>
          <el-form-item label="二次确认新密码">
            <el-input v-model.trim="form.newPasswdTwo" type="password" />
          </el-form-item>
          <el-form-item>
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { loupdatePwdgin } from '@/api/global'
import { getUserToken } from '@/api/task'
import { mapGetters } from 'vuex'
// import callInit from '@/utils/call'
export default {
  name: 'navbar',
  data() {
    return {
      dialogFormVisible: false,
      form: {}
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    name() {
      return this.currentUser.name
    }
  },
  watch: {
    currentUser(val) {
      // 外呼init
      if (val.id) this.getCallUserToken()
    }
  },
  methods: {
    async getCallUserToken() {
      sessionStorage.setItem('userId', this.currentUser.id)
      // const res = {
      //   "status": 1,
      //   "data": {
      //     "account_id": 10703318,
      //     "token": "d1e847ad-59b9-4a29-9eaa-163651b59c83"
      //   }
      // }
      // const res = await getUserToken({
      //   userId: this.currentUser.id
      // })
      // callInit(res)
    },
    /**
     * 修改密码
     */
    async confirm() {
      if (!this.form.mobile || !this.form.password || !this.form.newPasswd || !this.form.newPasswdTwo) return this.$message.error('请填写完整信息')
      if (this.form.newPasswd !== this.form.newPasswdTwo) return this.$message.error('新密码不一致')
      const { code } = await loupdatePwdgin(this.form)
      if (code === '00') {
        this.$message.success('操作成功')
        this.dialogFormVisible = false
      }
    },
    handleCommand(command) {
      switch (command) {
        case 'logout':
          this.$store.dispatch('LogOut').then(() => {
            this.$router.push({ path: '/login' })
          }).catch(() => {
          })
          break
        case 'updatePwd':
          this.dialogFormVisible = true
          break
      }
    }
  }
}
</script>

<style lang="scss">
html,
body,
#app {
  height: 100%;
}

body {
  margin: 0;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}

.el-icon-arrow-down {
  font-size: 16px;
}

.header {
  position: absolute;
  left: 0;
  top: 0;
  height: $header_height !important;
  font-size: 16px;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.1);
  background-color: $header_color;
  width: 100%;
  z-index: 2;
}

#logo {
  display: flex;
  align-items: center;
  float: left;
  font-size: 18px;
  line-height: $header_height;
  color: #fff;
  font-weight: 600;
}

#logo img {
  display: block;
  margin-right: 10px;
  width: 45px;
  height: 40px;
}

.nav {
  float: right;
  display: flex;
  min-height: $header_height;
  justify-content: space-between;
  align-items: center;

  #call-content {
    margin-right: 10px;

    div {
      border: none !important;
      // background: #333 !important;
    }
  }
}
</style>
